module.exports = __webpack_public_path__ + "static/img/RAPS600S_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS600S_1.png
// module id = LbiU
// module chunks = 0